import moment from 'moment-timezone';

export function omit<T extends object, K extends keyof T>(target: T, ...omitKeys: K[]): Omit<T, K> {
  return (Object.keys(target) as K[]).reduce(
    (res, key) => {
      if (!omitKeys.includes(key)) {
        res[key] = target[key];
      }
      return res;
    },
    {} as any
  );
}


export function formatDate(date: any) {
  const _moment = moment.utc(date).tz('America/New_York');

  return `${_moment.format('LLL')}`;
}
